import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SiteApiService } from '@services/api-calls/site-api.service';
import { ActivatedRoute } from '@angular/router';
import { Snackbar } from '@models/models';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-remember-password',
    templateUrl: './remember-password.component.html',
    styleUrls: ['./remember-password.component.scss'],
})
export class RememberPasswordComponent implements OnInit {
    public remember_form: FormGroup;
    public submitted: boolean = false;
    public reset_password: boolean = false;
    public url_token: string = null;
    public show_password: boolean = false;

    public valid_password: boolean = false;
    public capitalFlag: boolean = false;
    public numberFlag: boolean = false;
    public lengthFlag: boolean = false;
    public new_password: boolean = false;

    public snackbar: Snackbar = new Snackbar();
    public password_feedback: any;

    constructor(
        private formBuilder: FormBuilder,
        private _siteApiService: SiteApiService,
        private route: ActivatedRoute,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        // try to get token to url
        this.route.paramMap.subscribe((params) => {
            this.url_token = params.get('token');
        });

        // create a form builder
        this.remember_form = this.formBuilder.group({
            username: ['', [Validators.required, Validators.email]],
        });

        this.translate
            .get('REMEMBER_PASSWORD.rememberPassword_ok')
            .subscribe((translated: string) => {
                this.password_feedback = {
                    rememberPassword_ok: translated,
                    rememberPassword_error: this.translate.instant(
                        'REMEMBER_PASSWORD.rememberPassword_error'
                    ),
                    changePassword_ok: this.translate.instant(
                        'REMEMBER_PASSWORD.changePassword_ok'
                    ),
                    changePassword_error: this.translate.instant(
                        'REMEMBER_PASSWORD.changePassword_error'
                    ),
                };
            });
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.remember_form.controls;
    }

    onSubmit() {
        this.submitted = true;
        if (!this.remember_form.invalid) {
            this.rememberPassword(this.remember_form.value.username);
        }
    }

    rememberPassword(email: string) {
        this._siteApiService.resetPassword(email).subscribe(
            (response) => {
                this.reset_password = true;
                this.snackbar.setText(
                    this.password_feedback.rememberPassword_ok
                );
                this.snackbar.setStatusClass('success');
                this.snackbar.activate();
            },
            (error) => {
                console.log(error);
                this.snackbar.setText(
                    this.password_feedback.rememberPassword_error
                );
                this.snackbar.setStatusClass('error');
                this.snackbar.activate();
            }
        );
    }

    /**
     * Check if password is longer than 7,
     * has a Upper letter and at least 1 number
     * @param new_password the new user password
     */
    checkValidPassword(new_password: string) {
        let char;
        this.lengthFlag = new_password.length > 6 ? true : false;
        this.numberFlag = false;
        this.capitalFlag = false;
        for (let i = 0; i < new_password.length; i++) {
            char = new_password.charAt(i);
            if (Number(char)) {
                this.numberFlag = true;
            } else if (char === char.toUpperCase()) {
                this.capitalFlag = true;
            }
        }
        this.valid_password =
            this.numberFlag && this.capitalFlag && this.lengthFlag
                ? true
                : false;
    }

    changePassword() {
        const new_password = this.remember_form.value.password;
        this._siteApiService
            .resetPasswordConfirm(new_password, this.url_token)
            .subscribe(
                (response) => {
                    this.new_password = true;
                    this.snackbar.setText(
                        this.password_feedback.changePassword_ok
                    );
                    this.snackbar.setStatusClass('success');
                    this.snackbar.activate();
                },
                (error) => {
                    console.log(error);
                    this.snackbar.setText(
                        this.password_feedback.changePassword_error
                    );
                    this.snackbar.setStatusClass('error');
                    this.snackbar.activate();
                }
            );
    }
}
